import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagicEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26,
	height: 26,
	fill: "none",
	viewBox: "0 0 26 26",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M22 6H6c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2m0 2v.511l-8 6.223-8-6.222V8zM6 20v-8.956l7.386 5.745a.994.994 0 0 0 1.228 0L22 11.044 22.002 20z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#4183cb",
		d: "m0 7.26 4.993 1.934L7.195 14.5l1.959-5.306 5.345-1.933-5.345-2.007L7.194 0 5.41 5.254z"
	})]
});
export default SvgMagicEmail;
